import React from 'react'
import "./header.css"

function Header() {
  return (
    <div className='header-box' style={{
      backgroundImage:`url(${'/icons/banner.png'})`,
      backgroundSize:'cover',
      backgroundPosition:'center',
      height:'60vh',
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      width:'100vw'
    }}>

      <div  style={{
        width:'40%',
        backgroundColor:'#00290430',
        padding:'40px',
        borderRadius:'20px',
        textAlign:'center',
        border:'1px solid white'
        }}>
       
        <h1 className='header-h1'>Sadapoorna</h1>
        <p className='header-p'>Sadapoorna is a trusted name in the world of premium rice, committed to bringing the finest quality grains from farm to table. Rooted in tradition and driven by a passion for purity, Sadapoorna specializes in offering naturally grown, carefully processed rice that retains its rich aroma, nutritional value, and authentic taste.</p>
      </div>

      {/* <div style={{width:'40%'}}>
        <img className='header-img' src={"headerimg.png"} alt='img'/>
      </div> */}
      
    </div>
  )
}

export default Header
